/* prettier-ignore */
/**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */
//Czech
export default {
  'confluence-analytics-chart.default-loading-text': 'Obnovování dat analytiky…',
  'confluence-analytics-chart.tooltip.no-views-data': 'Žádná data',
  'confluence-analytics-chart.tooltip.views-overall':
    '{count, plural, one {1 zobrazení} few {{count} zobrazení} many {{count} zobrazení} other {{count} zobrazení}}',
  'confluence-analytics-chart.tooltip.views-today-so-far':
    '{count, plural, one {Zatím 1 zobrazení} few {Zatím {count} zobrazení} many {Zatím {count} zobrazení} other {Zatím {count} zobrazení}}',
  'confuence-analytics-chart.accessible-table.caption': 'Zobrazení stránky',
  'confuence-analytics-chart.accessible-table.header.date': 'Datum',
  'confuence-analytics-chart.accessible-table.header.view-count': 'Zobrazení',
  'confuence-analytics-chart.accessible-table.no-view-count-data': 'Žádná zobrazení',
};
